import { CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import MDBox from "./MDBox";

const Loading = ({ size = 40 }) => {
  return (
    <MDBox display="flex" justifyContent="center" p={3} my={8}>
      <CircularProgress size={size} />
    </MDBox>
  );
};

Loading.propTypes = {
  size: PropTypes.number,
};

Loading.defaultProps = {
  size: 40,
};
export default Loading;
